import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../src/environments/env';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  private apiUrl = environment.BASE_URL+`/ptp/`;
  public header = { headers: { 'Access-Control-Allow-Origin': '*' } }

  constructor(private http: HttpClient) { }


  public fetchDashboardData(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl + 'api/admin/dashboard/metrics', this.header);
  }

  public fetchDashboardDataList() {
     return this.http.get<any[]>(this.apiUrl + 'api/admin/user/report/mctcount', this.header);
  }

}
